function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { values } from 'ramda';
import { RouteParams } from 'invision-core/src/components/router/router.selectors';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { retrieveConvergentBillerOrderDetailsPromise } from './customer.convergent.biller.actions';
export var APPLY_CREDIT_CONSTANTS = {
  BEGIN: 'APPLY_CREDIT_BEGIN',
  SUCCESS: 'APPLY_CREDIT_SUCCESS',
  FAILURE: 'APPLY_CREDIT_FAILURE'
};
export var RESUBMIT_ORDER_CONSTANTS = {
  BEGIN: 'RESUBMIT_ORDER_BEGIN',
  SUCCESS: 'RESUBMIT_ORDER_SUCCESS',
  FAILURE: 'RESUBMIT_ORDER_FAILURE'
};
export var COMPLETE_ORDER_CONSTANTS = {
  BEGIN: 'COMPLETE_ORDER_BEGIN',
  SUCCESS: 'COMPLETE_ORDER_SUCCESS',
  FAILURE: 'COMPLETE_ORDER_FAILURE'
};
export var CLEAR_APPLY_CREDIT_ERRORS = 'CLEAR_APPLY_CREDIT_ERRORS';
var APPLY_CREDIT_EVENTS = [APPLY_CREDIT_CONSTANTS.BEGIN, APPLY_CREDIT_CONSTANTS.SUCCESS, APPLY_CREDIT_CONSTANTS.FAILURE];
var RESUBMIT_ORDER_EVENTS = [RESUBMIT_ORDER_CONSTANTS.BEGIN, RESUBMIT_ORDER_CONSTANTS.SUCCESS, RESUBMIT_ORDER_CONSTANTS.FAILURE];
var COMPLETE_ORDER_EVENTS = [COMPLETE_ORDER_CONSTANTS.BEGIN, COMPLETE_ORDER_CONSTANTS.SUCCESS, COMPLETE_ORDER_CONSTANTS.FAILURE];
export var clearApplyCreditErrors = function clearApplyCreditErrors() {
  return {
    type: CLEAR_APPLY_CREDIT_ERRORS
  };
};
export var applyOrderCredit = function applyOrderCredit(customerId, creditDetails) {
  return function (dispatch) {
    return ThunkHelper(dispatch, APPLY_CREDIT_EVENTS, {
      method: 'post',
      url: 'SubscriberManagement/ProcessCredit',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: creditDetails
    });
  };
};
export var resubmitOrder = function resubmitOrder(customerId, orderId) {
  return function (dispatch) {
    return ThunkHelper(dispatch, RESUBMIT_ORDER_EVENTS, {
      method: 'post',
      url: 'SubscriberManagement/ResubmitOrder',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        Id: orderId
      }
    }).then(function () {
      return retrieveConvergentBillerOrderDetailsPromise(dispatch, customerId, orderId);
    });
  };
};
export var completeOrder = function completeOrder(customerId, orderId) {
  return function (dispatch) {
    return ThunkHelper(dispatch, COMPLETE_ORDER_EVENTS, {
      method: 'post',
      url: 'SubscriberManagement/CompleteOrderPayment',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        OrderId: orderId
      }
    }, {
      customerId: customerId,
      orderId: orderId
    });
  };
};
export var CANCEL_ORDER_CONSTANTS = {
  BEGIN: 'CANCEL_ORDER_BEGIN',
  SUCCESS: 'CANCEL_ORDER_SUCCESS',
  FAILURE: 'CANCEL_ORDER_FAILURE'
};
export var CANCEL_PENDING_ORDER_CONSTANTS = {
  BEGIN: 'CANCEL_PENDING_ORDER_BEGIN',
  SUCCESS: 'CANCEL_PENDING_ORDER_SUCCESS',
  FAILURE: 'CANCEL_PENDING_ORDER_FAILURE'
};
export var cancelOrderPromise = function cancelOrderPromise(dispatch, customerId, orderId) {
  var issueRefund = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return ThunkHelper(dispatch, values(CANCEL_ORDER_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/CancelOrder',
    data: {
      Id: orderId,
      IssueRefund: issueRefund
    },
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var cancelPendingOrderPromise = function cancelPendingOrderPromise(dispatch, customerId, orderId) {
  return ThunkHelper(dispatch, values(CANCEL_PENDING_ORDER_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/CancelPendingOrder',
    data: {
      OrderId: orderId
    },
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var cancelOrder = function cancelOrder(customerId, orderId) {
  var issueRefund = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch) {
    return cancelOrderPromise(dispatch, customerId, orderId, issueRefund);
  };
};
export var cancelPendingOrder = function cancelPendingOrder(customerId, orderId) {
  return function (dispatch) {
    return cancelPendingOrderPromise(dispatch, customerId, orderId);
  };
};
export var RETRIEVE_ORDER_SERVICE_DETAILS = {
  BEGIN: 'RETRIEVE_ORDER_SERVICE_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_ORDER_SERVICE_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_ORDER_SERVICE_DETAILS_FAILURE'
};
export var retrieveOrderServiceDetailsPromise = function retrieveOrderServiceDetailsPromise(dispatch, orderId, customerId) {
  return ThunkHelper(dispatch, values(RETRIEVE_ORDER_SERVICE_DETAILS), {
    method: 'post',
    url: 'Workflow/RetrieveOrderServiceDetails',
    data: {
      OrderId: orderId,
      ReturnAllAvailableAttributeTypes: true
    }
  }, {
    CustomerId: customerId
  });
};
export var retrieveOrderServiceDetails = function retrieveOrderServiceDetails(orderId, customerId) {
  return function (dispatch) {
    return retrieveOrderServiceDetailsPromise(dispatch, orderId, customerId);
  };
};
export var UPDATE_ORDER_SERVICE_DETAILS = {
  BEGIN: 'UPDATE_ORDER_SERVICE_DETAILS_BEGIN',
  SUCCESS: 'UPDATE_ORDER_SERVICE_DETAILS_SUCCESS',
  FAILURE: 'UPDATE_ORDER_SERVICE_DETAILS_FAILURE'
};
export var updateOrderServiceDetailsPromise = function updateOrderServiceDetailsPromise(dispatch, orderId, orderItems) {
  return ThunkHelper(dispatch, values(UPDATE_ORDER_SERVICE_DETAILS), {
    method: 'post',
    url: 'Workflow/UpdateOrderServiceDetails',
    data: {
      OrderId: orderId,
      OrderItems: orderItems
    }
  });
};
export var updateOrderServiceDetails = function updateOrderServiceDetails(orderId, orderItems) {
  return function (dispatch) {
    return updateOrderServiceDetailsPromise(dispatch, orderId, orderItems);
  };
};
export var SEARCH_INVENTORY_FOR_UPDATE = {
  BEGIN: 'SEARCH_INVENTORY_FOR_UPDATE_BEGIN',
  SUCCESS: 'SEARCH_INVENTORY_FOR_UPDATE_SUCCESS',
  FAILURE: 'SEARCH_INVENTORY_FOR_UPDATE_FAILURE'
};
export var searchInventoryForUpdatingAttributesPromise = function searchInventoryForUpdatingAttributesPromise(dispatch, inventoryTypeId, customerId) {
  return ThunkHelper(dispatch, values(SEARCH_INVENTORY_FOR_UPDATE), {
    method: 'post',
    url: 'SubscriberManagement/SearchInventory',
    data: {
      InventoryTypeId: inventoryTypeId,
      PageSize: 6
    },
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var searchInventoryForUpdatingAttributes = function searchInventoryForUpdatingAttributes(inventoryTypeId) {
  return function (dispatch, getState) {
    var routeParams = RouteParams(getState());
    return searchInventoryForUpdatingAttributesPromise(dispatch, inventoryTypeId, routeParams.customerId);
  };
};
export var SEARCH_SUBSCRIBER_OFFERINGS_CONSTANTS = {
  BEGIN: 'SEARCH_SUBSCRIBER_OFFERINGS_BEGIN',
  SUCCESS: 'SEARCH_SUBSCRIBER_OFFERINGS_SUCCESS',
  FAILURE: 'SEARCH_SUBSCRIBER_OFFERINGS_FAILURE'
};
export var searchSubscriberOfferingsPromise = function searchSubscriberOfferingsPromise(dispatch, params, requestObj) {
  return ThunkHelper(dispatch, values(SEARCH_SUBSCRIBER_OFFERINGS_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscriberOfferings',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, params.customerId),
    data: {
      IncludeCoolingOff: true,
      IncludeOfferingTotals: params.includeOfferingTotals,
      OfferingInstanceIds: params.offeringInstanceIds,
      OfferName: params.offerName,
      PageNumber: params.pageNumber,
      PageSize: params.pageSize,
      Status: params.status
    }
  }, requestObj);
};
export var searchSubscriberOfferings = function searchSubscriberOfferings(params, requestObj) {
  return function (dispatch) {
    return searchSubscriberOfferingsPromise(dispatch, params, requestObj);
  };
};